import React, { useState, useEffect } from "react";

import { updatePassword } from "../services/authService";
import MfaSettings from "./mfa/MfaSettings";

const Account: React.FC = () => {
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [updatedPasswordSuccess, setUpdatedPasswordSuccess] = useState(false);

  // validate password whenever any field changes
  useEffect(() => {
    validatePasswords();
  }, [newPassword, newPasswordConfirmation]);

  const validatePasswords = () => {
    // reset error message
    setErrorMessage('');

    // check matching passwords
    if (newPasswordConfirmation && newPassword !== newPasswordConfirmation) {
      setErrorMessage('Passwords do not match');
      setIsValid(false);
      return;
    }

    // check length
    if (newPassword && newPassword.length < 8) {
      setErrorMessage('Password must be at least 8 characters long');
      setIsValid(false);
      return;
    }

    // check for letter, number, and symbol
    if (newPassword) {
      const hasLetter = /[a-zA-Z]/.test(newPassword);
      const hasNumber = /[0-9]/.test(newPassword);
      const hasSymbol = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(newPassword);

      if (!hasLetter || !hasNumber || !hasSymbol) {
        setErrorMessage('Password must contain at least one letter, one number, and one symbol');
        setIsValid(false);
        return;
      }
    }

    // if we get here and have a password, it's valid
    setIsValid(newPassword.length > 0 && newPasswordConfirmation.length > 0);
  };

  const handleSave = async () => {
    if (!isValid) return;
    try {
      await updatePassword(newPassword, newPasswordConfirmation);
      setUpdatedPasswordSuccess(true);

      // clear input fields
      setNewPassword('');
      setNewPasswordConfirmation('');
      setErrorMessage('');

      // clear success banner
      setTimeout(() => {
        setUpdatedPasswordSuccess(false);
      }, 1500);
    } catch (error: any) {
      console.error(error);
      setErrorMessage(error.response.data.error);
      setUpdatedPasswordSuccess(false);
    }
  };

  return (
    <div>
      <h1>Account</h1>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        maxWidth: '450px',
      }}>
        <h3 style={{ margin: "8px 0px" }}>Update Password</h3>

        { updatedPasswordSuccess && (
          <div
            style={{
              backgroundColor: "#e0f7df",
              color: "#2e7d32",
              border: "1px solid #2e7d32",
              borderRadius: "8px",
              padding: "8px 16px",
              marginBottom: "8px",
              maxWidth: "374px",
            }}
          >
            ✅
            <span style={{marginLeft: "12px"}}>Password successfully updated!</span>
        </div>
      )}

        {/* TODO: validate current password if the user already has one
        <input
          id="current_password"
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          placeholder="Current Password (if it exists)"
          className="url-input"
          style={{ width: '100%' }}
        /> */}

        <input
          id="new_password"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="New Password"
          className="url-input"
          style={{ width: '100%' }}
        />

        <input
          id="confirm_new_password"
          type="password"
          value={newPasswordConfirmation}
          onChange={(e) => setNewPasswordConfirmation(e.target.value)}
          placeholder="Confirm New Password"
          className="url-input"
          style={{ width: '100%' }}
        />

        {errorMessage && (
          <div style={{ color: 'red', fontSize: '14px' }}>
            {errorMessage}
          </div>
        )}

        <button
          className="primary-button"
          onClick={handleSave}
          disabled={!isValid}
          style={{
            marginTop: '10px',
            maxWidth: '96px',
            opacity: isValid ? 1 : 0.6,
          }}
        >
          Save
        </button>
      </div>

      <MfaSettings />
    </div>
  );
};

export default Account;
